import React, { Component } from "react";
import StatsFilterForm from "./stats_filter_form";
import { Col, Grid, Row, Tab, Tabs } from "react-bootstrap";
import Spinner from "../../lib/spinner";
import Map from "../../lib/mapbox";
import StatsTotalDownloads from "./stats_total_downloads";
import StatsEpisodeTable from "./stats_episode_table";
import StatsShowTable from "./stats_show_table";
import StatsCountryTable from "./stats_country_table";
import StatsCityTable from "./stats_city_table";
import UserRoles from "../../../constants/roles";
import uuid from "uuid/v4";
import get from "lodash/get";
import "./stats_page.scss";
import Divider from "../../lib/divider";
import { userHasRole } from "../../../lib/user";
import Papa from "papaparse";
import { aggregateStats } from "../../lib/stats/utils";
import { downloadFile } from "../../lib/download_file";
import { countryCodesMap } from "../../../data/countries";
import { titleCase } from "../../../lib/strings";
import { If } from "react-extras";
import { getData, getDateFormatted } from "../../lib/format_stats";
import { parse } from "query-string";
import moment from "moment";
import StatsAppTable from "./stats_app_table";
import known_agent_friendly from "../../../lib/known_agent_friendly";

var iconBreakpoint = 1250;

var initialValues = {
  timeRange: "allTime",
  statsType: "downloads",
  isUnique: "true",
};

const tabs = {
  downloads: "downloads",
  podcasts: "podcasts",
  episodes: "episodes",
  app: "app",
  country: "country",
  city: "city",
  geo: "geo",
};

class StatsPage extends Component {
  state = {
    currentTab: tabs.downloads,
    wideMode: true,
  };

  newRequestID = () => {
    this.statsRequestID = uuid();
    return this.statsRequestID;
  };

  setWidthMode = () => {
    this.setState({ wideMode: window.innerWidth > iconBreakpoint });
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.setWidthMode);
  }

  componentDidMount() {
    this.props.fetchStatsOptions();
    this.setWidthMode();
    window.addEventListener("resize", this.setWidthMode);

    if (userHasRole(this.props.user, UserRoles.Creator)) {
      initialValues.statsType = "downloads";
      this.props.fetchShowsForUser(this.props.user).then(response => {
        if (response.status !== 200) return;
        let shows = get(response, "json", []);
        shows = shows.filter(item => item.isVisible);
        if (shows.length && shows.length === 1) {
          this.setInitialShowUUID(shows[0].uuid);
        } else {
          const { showUUID } = parse(this.props.location.search);
          if (showUUID) {
            this.setInitialShowUUID(showUUID);
          }
        }
      });
    } else {
      initialValues.statsType = "insertions";
      this.fetchStatsWithFilters(initialValues);
    }
  }

  setInitialShowUUID = showUUID => {
    this.props.setShowUUID(showUUID);
    initialValues.showUUID = showUUID;
    this.props.fetchEpisodesForShow(showUUID, this.props.user);
    this.fetchStatsWithFilters(initialValues);
  };

  getStats = () => {
    return get(this.props, ["stats", this.statsRequestID], []);
  };

  fetchStatsWithFilters = filters => {
    if (this.state.currentTab === "geo") {
      return;
    }
    var finalFilters = {};
    Object.keys(filters || {}).forEach(key => {
      if (filters[key]) {
        finalFilters[key] = filters[key];
      }
    });
    if (finalFilters.timeRange === "custom") {
      finalFilters.arbitraryTimeRange = finalFilters.startEndDate
        .map(date => Math.floor(date / 1000))
        .join(",");
      delete finalFilters.startEndDate;
      delete finalFilters.timeRange;
    }
    switch (this.state.currentTab) {
      case tabs.episodes:
        finalFilters.bucketTerms = "download.episodeUUID";
        break;
      case tabs.podcasts:
        finalFilters.bucketTerms = "download.showUUID";
        break;
      case tabs.country:
        finalFilters.bucketTerms = "download.metadata.country";
        break;
      case tabs.city:
        finalFilters.bucketTerms = "download.metadata.city";
        break;
      case tabs.app:
        finalFilters.bucketTerms = "download.metadata.app";
        break;
      default:
        break;
    }
    return this.props.fetchStats(finalFilters, this.props.user, this.newRequestID());
  };

  downloadCSV = () => {
    let agg = aggregateStats(this.getStats());
    let unparseData;
    switch (this.state.currentTab) {
      case tabs.episodes:
        unparseData = Object.keys(agg).map(key => {
          return {
            name: get(this.props.episodesByShow, [this.props.showUUID, "episodes", key, "title"]),
            count: get(agg, [key, "count"]),
          };
        });
        break;
      case tabs.podcasts:
        unparseData = Object.keys(agg)
          .filter(key => get(this.props.shows, [key, "isVisible"]))
          .map(key => ({
            name: get(this.props.shows, [key, "title"]),
            count: get(agg, [key, "count"]),
          }));
        break;
      case tabs.country:
        unparseData = Object.keys(agg).map(key => ({
          country: countryCodesMap[key],
          count: get(agg, [key, "count"]),
        }));
        break;
      case tabs.app:
        unparseData = Object.keys(agg).map(key => ({
          app: known_agent_friendly.get("app", key),
          count: get(agg, [key, "count"]),
        }));
        break;
      case tabs.city:
        unparseData = Object.keys(agg)
          .filter(key => key && key !== "roseville")
          .map(key => ({
            city: titleCase(key),
            count: get(agg, [key, "count"]),
          }));
        break;
      case tabs.downloads:
        unparseData = getData(this.getStats()).map(data => {
          return {
            data: getDateFormatted({ original: data }, this.props.statsForm),
            count: data.count,
          };
        });
        break;
      default:
        return;
    }
    if (unparseData) {
      const csv = Papa.unparse(unparseData);
      downloadFile(`${this.state.currentTab}_stats.csv`, csv);
    }
  };
  renderDownloadButton = () => {
    return (
      <button className="btn btn-primary download-csv" onClick={this.downloadCSV}>
        Download CSV
      </button>
    );
  };

  render() {
    return (
      <div className="stats-page-wrapper page-wrapper">
        <Grid fluid>
          <Row>
            <Col xs={12}>
              <h1>Analytics</h1>
              <Divider smallMargin />
            </Col>
          </Row>
          <StatsFilterForm
            filters={this.props.statsForm}
            handleSubmit={() => {
              this.fetchStatsWithFilters(this.props.statsForm);
            }}
            initialValues={initialValues}
            shows={this.props.shows}
            setShowUUID={this.props.setShowUUID}
            selectedShowUUID={this.props.showUUID}
            fetchEpisodesForShow={this.props.fetchEpisodesForShow}
            user={this.props.user}
            episodesByShow={this.props.episodesByShow}
            clearEpisodeUUID={this.props.clearEpisodeUUID}
            statsOptions={this.props.statsOptions}
            currentTab={this.state.currentTab}
            clearShowUUID={this.props.clearShowUUID}
          />
          <div className={"stats-page__graph-wrapper"}>
            <Row>
              <Col xs={12}>
                <Tabs
                  unmountOnExit
                  mountOnEnter
                  id={"stats-page-tabs"}
                  activeKey={this.state.currentTab}
                  className="stats-page__tab-wrapper"
                  onSelect={key => {
                    this.setState({ currentTab: key }, () => {
                      this.fetchStatsWithFilters(this.props.statsForm);
                    });
                    if (key === "podcasts") {
                      this.props.clearShowUUID();
                    }
                    if (key === "podcasts" || key === "episodes") {
                      this.props.clearEpisodeUUID();
                    }
                  }}>
                  <Tab
                    eventKey={tabs.downloads}
                    title={
                      this.state.wideMode ? (
                        "Total Downloads"
                      ) : (
                        <span className="glyphicon glyphicon-cloud-download" />
                      )
                    }
                    className="stats-page__tab-panel">
                    <Spinner isLoading={this.props.isLoading} spinDelay={0} />
                    <StatsTotalDownloads
                      isLoading={this.props.isLoading}
                      data={this.getStats()}
                      statsForm={this.props.statsForm}
                      wideMode={this.state.wideMode}
                    />
                  </Tab>
                  <Tab
                    eventKey={tabs.podcasts}
                    title={
                      this.state.wideMode ? (
                        "By Podcast"
                      ) : (
                        <span className="glyphicon glyphicon-th-large" />
                      )
                    }
                    className="stats-page__tab-panel">
                    {!this.props.isLoading && (
                      <StatsShowTable
                        data={this.getStats()}
                        shows={this.props.shows}
                        episodesByShow={this.props.episodesByShow}
                        currentStat={this.state.statsRequestID}
                      />
                    )}
                  </Tab>
                  <Tab
                    eventKey={tabs.episodes}
                    title={
                      this.state.wideMode ? (
                        "By Episode"
                      ) : (
                        <span className="glyphicon glyphicon-th" />
                      )
                    }
                    className="stats-page__tab-panel">
                    <Spinner isLoading={this.props.isLoading} spinDelay={0} />
                    {!this.props.isLoading && (
                      <StatsEpisodeTable
                        data={this.getStats()}
                        showUUID={this.props.showUUID}
                        shows={this.props.shows}
                        episodesByShow={this.props.episodesByShow}
                        currentStat={this.state.statsRequestID}
                      />
                    )}
                  </Tab>
                  <Tab
                    eventKey={tabs.app}
                    title={
                      this.state.wideMode ? (
                        "By App"
                      ) : (
                        <span className="glyphicon glyphicon-phone" />
                      )
                    }
                    className="stats-page__tab-panel">
                    <Spinner isLoading={this.props.isLoading} spinDelay={0} />
                    {!this.props.isLoading && (
                      <StatsAppTable
                        data={this.getStats()}
                        currentStat={this.state.statsRequestID}
                      />
                    )}
                  </Tab>
                  <Tab
                    eventKey={tabs.country}
                    title={
                      this.state.wideMode ? (
                        "By Country"
                      ) : (
                        <span className="glyphicon glyphicon-flag" />
                      )
                    }
                    className="stats-page__tab-panel">
                    {!this.props.isLoading && <StatsCountryTable data={this.getStats()} />}
                  </Tab>
                  <Tab
                    eventKey={tabs.city}
                    title={
                      this.state.wideMode ? (
                        "By City"
                      ) : (
                        <span className="glyphicon glyphicon-map-marker" />
                      )
                    }
                    className="stats-page__tab-panel">
                    {!this.props.isLoading && <StatsCityTable data={this.getStats()} />}
                  </Tab>
                  <Tab
                    eventKey={tabs.geo}
                    title={
                      this.state.wideMode ? (
                        "Map"
                      ) : (
                        <span className="glyphicon glyphicon glyphicon-globe" />
                      )
                    }
                    className="stats-page__tab-panel">
                    <Map filters={this.props.statsForm} />
                  </Tab>
                </Tabs>
              </Col>
            </Row>
          </div>
        </Grid>
        <div className={"flex-row-container justify-space-between align-center"}>
          <If condition={this.state.currentTab !== tabs.geo}>{this.renderDownloadButton()}</If>
          <div className={"flex-1"} />
          <If condition={get(this.props.statsForm, "timeRange") === "custom"}>
            <div className={"bold date-range "}>
              {moment(get(this.props.statsForm, "startEndDate.0", null)).format("LL")}
              {" - "}
              {moment(get(this.props.statsForm, "startEndDate.1", null)).format("LL")}
            </div>
          </If>
        </div>
      </div>
    );
  }
}

export default StatsPage;
